module.exports = __webpack_public_path__ + "img/5_9.f7854c1a.png";